var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.page ? _c('div', [_c('vue-title', {
    attrs: {
      "title": "Tracks - Whoosh! Your Indoor Cycling Solution"
    }
  }), _c('Banner', {
    attrs: {
      "page": _vm.page
    }
  }), _c('div', {
    staticClass: "track-main"
  }, [_c('section', {
    staticClass: "container"
  }, _vm._l(_vm.page.tracks, function (track, i) {
    return _c('div', {
      key: i,
      staticClass: "row"
    }, [_c('section', {
      staticClass: "col-md-12 track-1"
    }, [_c('h3', [_vm._v(_vm._s(track.trackTitle))]), _c('p', {
      domProps: {
        "innerHTML": _vm._s(track.trackDescription)
      }
    }), _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: _vm.image(track.trackImage),
        expression: "image(track.trackImage)"
      }],
      staticClass: "img-fluid",
      attrs: {
        "alt": ""
      }
    }), _c('div', {
      staticClass: "space-20"
    })])]);
  }), 0)])], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }